<router-outlet></router-outlet>
<p-toast position="bottom-center"></p-toast>
<ngx-ui-loader bgsColor="rgb(255,255,255)" bgsOpacity="0.5" bgsPosition="bottom-right" bgsSize="60"
	bgsType="ball-spin-clockwise" delay="0" fgsColor="#F4B23D" fgsPosition="center-center" fgsSize="30"
	fgsType="rectangle-bounce" gap="5" logoPosition="center-center" logoSize="180"
	logoUrl="/assets/images/logos/complete-logo-dark.svg" overlayBorderRadius="0" overlayColor="rgb(255,255,255)"
	pbColor="#F4B23D" pbDirection="ltr" pbThickness="10" hasProgressBar="true" text="" textColor="#3e3e3e"
	textPosition="center-center" maxTime="-1" minTime="50"></ngx-ui-loader>